import React, { createContext, useState } from "react";

import { useNavigate, useLocation } from "react-router";
import RoutConstants from "../../../constants/routeConstants.json";
export const WaterHeaterUserDeviceListPageContext = createContext({});
export const WaterHeaterUserDeviceListPageContextProvider = ({ children }) => {
  const [count, setCount] = useState(8);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const deviceList = location?.state?.result;
  const catogoryId = localStorage.getItem("dashboard_Id");
  const navigateToDeviceDashboard = (modelName) => {

      navigate({
        pathname: RoutConstants.WATER_HEATER_DEVICE_DATA,
        search: "?waterheater=singleWaterheater",
      });
   
   
 
    localStorage.setItem("model", modelName);
  };
  const providerValue = {
    count,
    deviceList,
    navigateToDeviceDashboard,
  };
  return (
    <WaterHeaterUserDeviceListPageContext.Provider value={providerValue}>
      {children}
    </WaterHeaterUserDeviceListPageContext.Provider>
  );
};
